import { SvgIconProps } from "@mui/material/SvgIcon";
import { it } from "node:test";

interface BoldIconProps extends SvgIconProps {
  strokeWidth?: number;
}

const ItalicIcon: React.FC<BoldIconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      className="lucide lucide-italic-icon lucide-italic"
    >
      <line x1="19" x2="10" y1="4" y2="4" />
      <line x1="14" x2="5" y1="20" y2="20" />
      <line x1="15" x2="9" y1="4" y2="20" />
    </svg>
  );
};

export default ItalicIcon;
